export default {"src":"/_next/static/image/public/assets/icons/menu.6bb954217014b0e8ec90176d7ca67f4f.svg","height":20,"width":20};